import { Box, Button, FileInput, Input, LoadingOverlay, Paper, Select, SimpleGrid, Space, Text, TextInput, Title } from '@mantine/core'
import React, { memo, useEffect, useState } from 'react'
import useFetch from '../../../../Customhooks/useFetch';
import { useNavigate, useParams } from 'react-router-dom';
import { baseUrl } from '../../../../Constants/constant';
import { notifications } from '@mantine/notifications';
import classes from '../ManageProcess.module.css';



const Addrawmaterial = () => {
    const navigate = useNavigate();
    const [process, setProcess] = useState<string>('');
    const [errors, setErrors] = useState<Record<string, string>>({});
    const token = localStorage.getItem("token")
    const { id } = useParams();
    const method = id ? 'PUT' : 'POST'
    const url = id ? `${baseUrl}admin/process/update/${id}` : `${baseUrl}admin/process/add`
    const {
        data: getData,
        loading: detailLoading,
        error: getError,
        fetchData: postmaterial,
    } = useFetch({
        method: method,
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "token": token
        },
        body: JSON.stringify({
            process_name: process,
        }),
    });
    const {
        data: getfieldData,
        loading: getfieldLoading,
        error: getfielderror,
        fetchData: getfield,
    } = useFetch({
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "token": token
        },
    });
    useEffect(() => {
        if (id) {
            getfield(`${baseUrl}admin/process/${id}`)
        }
    }, [])
    useEffect(() => {
        if (getfieldData?.data?.rows?.length) {
            setProcess(getfieldData.data.rows[0].process_name);
        }
    }, [getfieldData]);

    // **Reusable function to handle input change and remove errors**
    const handleChange = (field: string, value: string | null) => {
        if (field === "Process_name") {
            setProcess(value as string);
        }

        // Remove the error for the field if it's being updated
        setErrors((prev: any) => ({ ...prev, [field]: undefined }));
    };

    // **Validate inputs before submitting**
    const validateFields = () => {
        let newErrors: Record<string, string> = {};

        if (!process.trim()) {
            newErrors.Process_name = "Process Name is Required";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return false; // Validation failed
        }
        return true; // Validation passed
    };

    const handlesave = async () => {
        if (!validateFields()) return
        await postmaterial(url);
    };

    // UseEffect to show notification when getData or getError changes
    useEffect(() => {
        const showNotification = (type: any, title = "An error occurred") => {
            notifications.show({
                title,
                message: type === 'success'
                    ? "Process data saved successfully."
                    : "Something went wrong. Please try again.",
                color: type === 'success' ? "green" : "red",
                classNames: classes,
            });
        };

        if (getData?.errors || getError) {
            showNotification('error', getData?.message || getError?.message);
            return;
        }

        if (getData && !getData?.errors) {
            navigate('/manage-process');
        }
    }, [getData, getError, navigate, classes]);



    return (
        <>
            <LoadingOverlay
                visible={getfieldLoading}
                zIndex={1000}
                overlayProps={{
                    radius: 'sm',
                    blur: 2,
                    style: {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%'
                    }
                }}
                loaderProps={{ color: '#404040', type: 'bars' }}
            />
            <Paper shadow="xs" p="xs" radius="md">
                <Box ml={5}>
                    <Title order={4}>Add Process</Title>
                    <Space h="lg" />
                    <Text>Process Details</Text>
                    <Space h="xs" />
                    <SimpleGrid cols={4}>
                        <TextInput
                            variant='filled'
                            label="Process Name"
                            withAsterisk
                            value={process}
                            onChange={(e) => handleChange("Process_name", e.target.value)}
                            placeholder="Enter Process Name"
                            radius={6}
                            error={errors.Process_name}
                        />

                    </SimpleGrid>
                    <Space h="xl" />
                    <SimpleGrid cols={6}>
                        <Button
                            variant="default"
                            radius={6}
                            onClick={() => navigate('/manage-process')}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="gradient"
                            gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                            radius={6}
                            onClick={handlesave}
                            loading={detailLoading}
                        >
                            {id ? 'Update' : 'Save'}
                        </Button>
                    </SimpleGrid>
                </Box>
            </Paper>
        </>
    )
}

export default memo(Addrawmaterial)